import React from 'react';
import { useNavigate } from 'react-router-dom';
import useStoreStore from 'zustands/useStoreStore';
import useUserStore from 'zustands/useUserStore';

const useLogout = () => {
  const navigate = useNavigate();

  const { setUserInfo, setISP } = useUserStore();
  const { setStoreInfo } = useStoreStore();

  const logoutFn = () => {
    setUserInfo({ userId: '', userToken: '' });
    setStoreInfo({ storeSeq: '', storeName: '', storeSeqNumber: 0 });
    setISP(false);
    navigate('/login');
  };

  return logoutFn;
};

export default useLogout;
